<template>
  <div id="app">
    <div class="wrapper">
      <Header v-if="user" />
      <router-view />
    </div>
  </div>
</template>

<script>
// import SysUtils from '@/base/utils/SysUtils'
import Header from '@/components/organisms/OrHeader'

export default {
  name: 'App',
  components: {
    Header
  },
  data () {
    let userToken = localStorage.getItem('fs_token')
    let userId = localStorage.getItem('fs_user_id')
    return {
      user_token: userToken,
      user_id: userId
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user) {
        return true
      }
      return false
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
  }
}
</script>

<style>
.form-group > label {
  font-weight: bold !important;
}
.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
</style>
